export const eUserPermissions = {
  UNKNOWN: { value: -1, name: 'Unknown' },
  EnableUser: { value: 0, name: 'Enable user' },
  DisableUser: { value: 1, name: 'Disable user' },
  ScanHost: { value: 2, name: 'Scan host' },
  ShutDown: { value: 3, name: 'Shut down' },
  Restart: { value: 4, name: 'Restart' },
  ChangeIp: { value: 5, name: 'Change IP' },
  DisableNics: { value: 6, name: 'Disable NICs' },
  RunCommand: { value: 7, name: 'Run command' },
  BlockTraffic: { value: 8, name: 'Block traffic' },
  //Analyze: { value: 9, name: 'Analyze' }, Obsolete
  VerifyFile: { value: 10, name: 'Verify file' },
  QuarantineFile: { value: 11, name: 'Quarantine file' },
  DeleteFile: { value: 12, name: 'Delete file' },
  SetStatus: { value: 13, name: 'Set Alerts status' },
  SendtoSOCAnalysis: { value: 14, name: 'Send to SOC & Analysis' },
  ViewSettings: { value: 15, name: 'View settings' },
  EditSettings: { value: 16, name: 'Edit settings' },
  EditCustomSearch: { value: 17, name: 'Edit custom search' },
  EditPolicies: { value: 18, name: 'Edit policies' },
  WorldOfFiles: { value: 19, name: 'View file data' },
  WorldOfHosts: { value: 20, name: 'View host data' },
  WorldOfUsers: { value: 21, name: 'View user data' },
  WorldOfNetwork: { value: 22, name: 'View network data' },
  DeepScan: { value: 24, name: 'Deep scan' },
  //ServiceOperations: { value: 25, name: 'Service operations' }, Obsolete
  Kill: { value: 26, name: 'Kill process' },
  AutoRemediation: { value: 27, name: 'Auto remediation' },
  ApiFullAccess: { value: 28, name: 'API - full access' },
  DisableService: { value: 29, name: 'Disable service' },
  DeleteService: { value: 30, name: 'Delete service' },
  DisableTask: { value: 31, name: 'Disable task' },
  DeleteTask: { value: 32, name: 'Delete task' },
  RunExecutable: { value: 33, name: 'Run script' },
  //GetStrings: { value: 34, name: 'Get strings' }, Obsolete
  //RouteByDns: { value: 35, name: 'Route by Dns' }, Obsolete
  PullFile: { value: 36, name: 'Pull file' },
  Isolate: { value: 37, name: 'Isolate' },
  ViewAudit: { value: 38, name: 'View audit' },
  ViewReports: { value: 39, name: 'View reports' },
  ViewMaps: { value: 40, name: 'View maps' },
  CustomRemActions: { value: 41, name: 'Custom remediation actions' },
  DeceptionNetwork: { value: 42, name: 'Deception network' },
  ManageSites: { value: 43, name: 'Manage sites' }, // only for operator
  ApiBasicCommands: { value: 44, name: 'API - basic commands' },
  CreateUser: { value: 45, name: 'Create user' },
  CreateRole: { value: 46, name: 'Create role' },
  ChangeRole: { value: 47, name: 'Change role' },
  ChangeAssetGroup: { value: 48, name: 'Change asset group' },
  ViewSspm: { value: 49, name: 'View SSPM' },
  UnQuarantine: { value: 50, name: 'Un-quarantine file' },
  ViewSiem: { value: 51, name: 'View CLM' }
};

export const eUserMfaActions = {
  Remove: { value: 0, name: 'Remove MFA' },
  Enable: { value: 1, name: 'Assign MFA' },
  Resync: { value: 2, name: 'Resync MFA' },
  UpdatePhoneNumber: { value: 3, name: ' Update Phone Number' }
};

export const eUserMfaStatus = {
  NotSet: { value: 0, name: 'Not Set' },
  Initialize: { value: 1, name: 'Initialize' },
  Synced: { value: 2, name: 'Synced' }
};

export const PermissionsMsg = {
  Msg: 'Insufficient permissions'
};
